/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useRef } from "react";
import { ClientContext } from "../../context/Client/ClientContext";

const SearchByCompany = ({ resetSearchByBtnState }) => {
  const {
    isClientSelected,
    showClientList,
    hideClientList,
    getClientsByCompanyName,
    clearSelectedClient,
    setCompanySearchName,
    companyNameSearch,
    clearCompanyNameSearch,
    clientListEmpty,
  } = useContext(ClientContext);

  const [companyName, setCompanyName] = useState("");
  const [placeHolder, setPlaceHolder] = useState(true);
  const [disabled, setDisabled] = useState(true);

  const typingTimerRef = useRef(null);

  useEffect(() => {
    clearCompanyNameSearch();
    setCompanyName(companyNameSearch || "");

    return () => {
      if (typingTimerRef.current) {
        clearTimeout(typingTimerRef.current);
      }
    };
  }, []);

  const runCompanySearch = async (value) => {
    const trimmedCompanyName = value.trim();

    if (trimmedCompanyName.length <= 2) {
      hideClientList();
      clearSelectedClient();
      return;
    }

    await getClientsByCompanyName(trimmedCompanyName);
    showClientList();
    setPlaceHolder(false);
  };

  const handleCompanyNameChange = (e) => {
    const value = e.target.value;

    setCompanyName(value);
    setCompanySearchName(value);
    setPlaceHolder(true);
    hideClientList();

    setDisabled(value.trim().length <= 2);

    if (typingTimerRef.current) {
      clearTimeout(typingTimerRef.current);
    }

    typingTimerRef.current = setTimeout(() => {
      runCompanySearch(value);
    }, 400);
  };

  const handleBackBtn = () => {
    if (isClientSelected) {
      clearSelectedClient();
      clearCompanyNameSearch();
    } else {
      resetSearchByBtnState();
      clearCompanyNameSearch();
      hideClientList();
    }
  };

  const handleOnSearch = async () => {
    await runCompanySearch(companyName);
  };

  const handleOnclickCompany = () => {
    setPlaceHolder(true);
  };

  const handleKeyup = (e) => {
    if (e.key === "Enter") {
      handleOnSearch();
    }
  };

  return (
    <div className="gog-search-input-panel">
      <div className="gog-field">
        <label>Company Name</label>

        <input
          autoFocus
          type="text"
          value={companyName}
          onClick={handleOnclickCompany}
          onKeyUp={handleKeyup}
          onChange={handleCompanyNameChange}
          placeholder="Enter company name"
        />

        {placeHolder && (
          <small>Type at least 3 characters to search by company name.</small>
        )}

        {clientListEmpty && !placeHolder && (
          <div className="gog-form-message error">No results found.</div>
        )}
      </div>

      <div className="gog-form-actions">
        <button type="button" className="gog-light-btn" onClick={handleBackBtn}>
          Back
        </button>

        <button
          type="button"
          className="gog-primary-btn"
          onClick={handleOnSearch}
          disabled={disabled && !isClientSelected}
        >
          Search
        </button>
      </div>
    </div>
  );
};

export default SearchByCompany;